<template>
  <!-- roll房管理-roll房详情 -->
  <div class="room-detail">
    <h1 v-if="detail" style="margin-bottom: 20px; font-size: 24px">
      <span style="margin-right: 20px">{{ detail.name }}</span>
      <el-tag v-if="detail.state === 1">未开始</el-tag>
      <el-tag v-if="detail.state === 2" type="success">正在抽奖</el-tag>
      <el-tag v-if="detail.state === 3" type="info">抽奖结束</el-tag>
      <el-tag v-if="detail.state === 4" type="danger">删除</el-tag>
      <el-button icon="el-icon-back" class="pull-right" @click="$router.back()">返回</el-button>
    </h1>
    <el-row v-if="detail" class="detail-row">
      <div class="row-flex">
        <h1 class="title">房间描述</h1>
        <p>{{ detail.remark }}</p>
      </div>
      <div class="row-flex">
        <h1 class="title">房间封面图</h1>
        <img :src="detail.image" alt="" />
      </div>
    </el-row>

    <div class="detail-prize" style="margin-bottom: 60px">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <h1 class="title pull-left">房间奖品</h1>
        </el-form-item>
        <el-form-item>
          <el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
            style="display: inline-flex; margin-right: 10px" :action="action" :headers="headers">
            <el-button size="mini" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="handleExport">导出上传冻结用户</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="visiblePrize = true">添加饰品</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="visibleKey = true">添加钥匙和钻石</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="handleExport1">未中奖人员导出</el-button>
        </el-form-item>
      </el-form>

      <!-- </el-row> -->
      <el-table :data="prize" v-loading="tableLoading">
        <el-table-column prop="id" label="奖品ID" width="100px">
          <template slot-scope="{ row }">{{ row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="奖品名称">
          <template slot-scope="{ row }">{{ row.prize.name }}</template>
        </el-table-column>
        <el-table-column prop="second_name" label="第二名称">
          <template slot-scope="{ row }">{{ row.prize.second_name }}</template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <img width="80" class="table-image" :src="row.prize.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="{ row }">{{ row.prize.price }}</template>
        </el-table-column>
        <!-- <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
            getCategoryName(row.prize.category_id)
          }}</template>
        </el-table-column> -->
        <el-table-column prop="status" label="等级">
          <template slot-scope="{ row }">
            <span :style="`color: ${getRankColor(row.prize.rank)};`">{{
                getRank(row.prize.rank)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="获奖用户">
          <template slot-scope="{ row }">
            <div class="select-user" v-if="row.user_id">
              <img :src="row.user_avatar || '/images/default-avatar.jpg'" alt />
              <p :title="row.user_name">{{ row.user_name }}</p>
            </div>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否首页展示">
          <template slot-scope="{ row }">{{
            row.is_show === 1 ? '是' : ''
          }}</template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="detail-user">
      <h1 class="title">加入用户</h1>
      <ul class="user-list">
        <li class="user-item" v-for="item in users" :key="item.id">
          <img :src="item.avatar || '/images/default-avatar.jpg'" alt />
          <p :title="item.name">{{ item.name }}</p>
        </li>
      </ul>
      <el-pagination background :page-size="usersMeta.per_page || 100" :total="usersMeta.total || 0"
        :current-page="userPage" @current-change="handleUserPageChange"
        v-if="usersMeta && usersMeta.total > usersMeta.per_page"></el-pagination>
    </div>

    <!-- 奖品弹窗 -->
    <el-dialog :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
      <el-row style="margin-bottom: 20px">
        <el-input style="width: 200px; margin-right: 20px" placeholder="奖品名称搜索" v-model="query.prizeName"></el-input>
        <el-input v-model="query.min_price" placeholder="最小价格" style="width: 150px; margin-right: 5px"></el-input>
        -
        <el-input v-model="query.max_price" placeholder="最大价格"
          style="width: 150px; margin-left: 5px; margin-right: 20px"></el-input>
        <el-button type="primary" @click="getPrize(1)" style="margin-right: 20px">搜索</el-button>
        <el-input style="width: 150px; margin-right: 20px" placeholder="请输入奖品数量" v-model="prizeNum"></el-input>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i class="el-icon-plus" title="添加" @click="handleAddPrize(item.id, prizeNum)"></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                  getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination background :page-size="prizeListMeta.per_page || 15" :total="prizeListMeta.total || 0"
        :current-page="prizeListMeta.current_page" @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"></el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="visibleKey" :close-on-click-modal="false" width="350px">
      <el-form :model="formKeyData" label-width="80px" :rules="keyRules" ref="form">
        <el-form-item prop="prize_type" label="奖品类型">
          <el-select v-model="formKeyData.prize_type" placeholder="请选择饰品类型">
            <el-option label="箱子钥匙" :value="2"></el-option>
            <el-option label="钻石" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="key_id" label="钥匙列表" v-if="formKeyData.prize_type === 2">
          <el-select v-model="formKeyData.key_id" placeholder="请选择钥匙">
            <el-option v-for="item in giftBoxList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="amount" label="钻石金额" v-if="formKeyData.prize_type === 3">
          <el-input v-model="formKeyData.amount" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item prop="num" label="数量">
          <el-input v-model="formKeyData.num" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="visibleKey = false">取 消</el-button>
          <el-button size="small" type="primary" @click="
            handleAddPrize(
              formKeyData.prize_type === 2
                ? formKeyData.key_id
                : formKeyData.amount,
              formKeyData.num,
              formKeyData.prize_type
            )
          " :loading="buttonLoading">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :visible.sync="visibleEdit" title="编辑用户" :close-on-click-modal="false" width="300px">
      <el-form :model="formData">
        <!-- <el-form-item prop="is_show" label="首页展示">
          <el-switch
            v-model="formData.is_show"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item> -->
        <el-form-item prop="user_id" label="获奖用户">
          <div class="select-user" v-if="selectUser">
            <img :src="selectUser.avatar || '/images/default-avatar.jpg'" alt />
            <p class="user-name" :title="selectUser.name">
              {{ selectUser.name }}
            </p>
            <div class="delete-button" @click="handleRemove">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="add-button" @click="visibleUser = true" v-else>
            <i class="el-icon-plus"></i>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEdit = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 参与用户弹窗 -->
    <el-dialog :visible.sync="visibleUser" title="选择用户" :close-on-click-modal="false" width="1000px">
      <div style="margin-bottom: 20px">
        <el-input v-model="username" placeholder="输入用户名以搜索" style="width: 200px; margin-right: 20px"></el-input>
        <el-button type="primary" @click="getUsers(null)">搜索</el-button>
      </div>
      <ul class="user-list">
        <li class="user-item" v-for="item in users" :key="item.id" @click="handleSelectUser(item)">
          <img :src="item.avatar || '/images/default-avatar.jpg'" alt />
          <p :title="item.name">{{ item.name }}</p>
        </li>
      </ul>
      <el-pagination background :page-size="usersMeta.per_page || 100" :total="usersMeta.total || 0"
        :current-page="userPage" @current-change="handleUserPageChange"
        v-if="usersMeta && usersMeta.total > usersMeta.per_page"></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import http, { api, server, delData, getData, patchData, postData, getApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import { mapState, mapActions } from 'vuex'
import saveFile from '@/utils/saveFile'
import ranks from '@/utils/ranks'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      tableLoading: false,
      userLoading: false,
      prize: undefined, // 房间奖品
      users: undefined,
      usersMeta: {}, // 房间用户
      userPage: 1,
      query: {//搜索信息
        page: 1,
        prizeName: '',
        min_price: undefined,
        max_price: undefined,
        num: undefined
      },
      detail: undefined,
      // 待选奖品
      visiblePrize: false,//添加饰品显示弹窗标志
      visibleKey: false,//添加钻石或钥匙显示弹窗标志
      loadingPrize: false,
      prizeListMeta: {},
      prizeList: undefined,
      prizeNum: 1,//添加奖品时要添加的数量
      // 编辑
      visibleEdit: false,
      formData: {
        is_show: 0,
        user_id: undefined
      },
      formKeyData: {//钥匙或钻石弹窗
        prize_type: undefined,//饰品类型
        num: 1,//数量
        key_id: undefined,//钥匙id
        amount: undefined,//金额
      },
      giftBoxList: undefined,//赠送钥匙列表
      editInfo: undefined,
      buttonLoading: false,
      // 用户列表
      visibleUser: false,
      selectUser: undefined,
      username: '',
      keyRules: {
        prize_type: [{ required: true, message: '请选择饰品类型' }],
        num: [{ required: true, message: '请输入数量' }],
      }
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    cid() {
      return this.$route.query.cid
    },
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}rooms/user_import/${this.id}`
    }
  },
  watch: {
    visibleKey(val) {
      if (val) {
        this.getGiftBox()
      }
    },
    editInfo(val) {
      const { is_show, user_id } = val
      this.formData = {
        is_show,
        user_id
      }
      if (val.user_id) {
        this.selectUser = {
          id: val.user_id,
          name: val.user_name,
          avatar: val.user_avatar
        }
      } else {
        this.selectUser = undefined
      }
    }
  },
  methods: {
    ...mapActions(['getCategories']),
    getDetail(init) {
      this.tableLoading = true
      getData(`rooms/${this.id}`)
        .then(res => {
          this.prize = res.data.user_prize
          this.detail = res.data
          init && this.getUsers(res.data.id)
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    getRank(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getPrize(num) {
      if (num === 1) {
        this.query.page = 1
      }
      if (!this.cid) {
        return
      }
      this.loadingPrize = true
      let params = {
        category_id: this.cid,
        page: this.query.page,
        name: this.query.prizeName,
        min_price: this.query.min_price,
        max_price: this.query.max_price
      }
      getData(`prize`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    getUsers(id) {
      if (!id) {
        id = this.detail.id
      }
      this.userLoading = true
      getData(`rooms/${id}/room_user`, {
        page: this.userPage,
        name: this.username
      }).then(res => {
        this.users = res.data
        this.usersMeta = res.meta
      })
    },
    handlePrizePageChange(page) {
      this.query.page = page
      this.getPrize()
    },
    handleUserPageChange(page) {
      this.userPage = page
      this.getUsers()
    },
    handleSelectUser(user) {
      this.selectUser = user
      this.formData.user_id = user.id
      this.visibleUser = false
    },
    handleRemove() {
      this.selectUser = undefined
      this.formData.user_id = undefined
    },
    handleAddPrize(id, num, type) {
      patchData(`rooms_add_prize/${this.id}`, {
        prize_type: type,
        id: [id],
        num: Number(num)
      }).then(res => {
        this.$message.success('添加成功')
        this.visiblePrize = false//关闭弹窗
        this.visibleKey = false//关闭弹窗
        this.getDetail()
      })
    },
    handleEdit(data) {
      this.visibleEdit = true
      this.editInfo = data
    },
    submit() {
      this.buttonLoading = true
      patchData(`rooms/${this.editInfo.id}/prize`, {
        // is_show: this.formData.is_show,
        user_id: this.selectUser ? this.selectUser.id : '',
        user_avatar: this.selectUser ? this.selectUser.avatar : '',
        user_name: this.selectUser ? this.selectUser.name : ''
      })
        .then(res => {
          this.$message.success('编辑成功')
          this.visibleEdit = false
          this.getDetail()
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData(`rooms_delete_prize/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getDetail()
        })
      })
    },
    getGiftBox(id) {
      //获取赠送盒子的钥匙数量
      let params = {
        user_id: 1
      }
      getApiData(`user_exp_boxes`, params, {
      })
        .then(res => {
          if (res) {
            this.giftBoxList = res
          }
        })
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    // 导出上传冻结用户
    handleExport() {
      http
        .get(
          api + `rooms/roll_freeze_export/${this.id}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '上传冻结用户.xlsx'
          })
        }).finally(() => {
        })
    },
    //未中奖人员导出
    handleExport1() {
      http
        .get(
          api + `rooms/roll_no_rain_export/${this.id}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '未中奖人员.xlsx'
          })
        }).finally(() => {
        })
    },
  },
  created() {
    this.getDetail(true)
    this.getPrize(1)
    !this.categories && this.getCategories()
  }
}
</script>

<style>

</style>
